import * as actionTypes from './actionTypes';
import { JobModel } from '@app/src/views/StepOne/form/models/job';

interface State {
  data: JobModel[];
  isFetching: boolean;
  error: boolean;
  selected: string;
  message: string;
}

const initialState: State = {
  data: [],
  isFetching: false,
  error: false,
  selected: '',
  message: ''
}

export const opportunity = (state = initialState, action): State => {
  switch (action.type) {
    case actionTypes.FETCH_OPPORTUNITY_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_OPPORTUNITY_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_OPPORTUNITY_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    case actionTypes.SET_OPPORTUNITY_MESSAGE:
      return {
        ...state,
        message: action.message
      }
    case actionTypes.CLEAR_OPPORTUNITY_MESSAGE:
      return {
        ...state,
        message: ''
      }
    case actionTypes.CLEAR_OPPORTUNITY_DATA:
      return {
        ...state,
        data: [],
        message: ''
      }
    case actionTypes.SET_OPPORTUNITY_SELECTED:
      return {
        ...state,
        selected: action.selected
      }
    case actionTypes.CLEAR_OPPORTUNITY_SELECTED:
      return {
        ...state,
        selected: ''
      }
    default:
      return state;
  }
}
